window.mcb.utilities.browser = (function () {
  let getUrlParameterOrFallbackFromUrl = function (name, fallback = "", url = window.location.href) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    let regexS = "[\\?&]" + name + "=([^&#]*)";
    let regex = new RegExp(regexS);
    let results = regex.exec(url);
    if (typeof results === 'undefined' || results === null) {
      const parts = name.split('-');
      if (parts.length === 1) {
        return fallback;
      }

      const abbr = parts.map((word) => word[0]).join('');
      return getUrlParameterOrFallbackFromUrl(abbr, fallback, url);
    }
    else {
      return results[1];
    }
  }

  let evaluateUrlParameterAsBool = function (value, strict = false) {
    if (value === "1" || value === "true" || value === "yes") {
      return true;
    }

    if (!strict || value === "0" || value === "false" || value === "no") {
      return false;
    }

    return value;
  }

  let getUrlBooleanParameter = function (name, strict = true) {
    let val = getUrlParameterOrFallbackFromUrl(name, null);
    return evaluateUrlParameterAsBool(val, strict);
  }

  let isMobileDevice = () => {
    return /Mobi|Android|iPhone/i.test(navigator.userAgent);
  }

  let isTabletDevice = () => {
    // Check for iPad, iPad Air, iPad Pro, and other tablets
    return /iPad|Tablet/i.test(navigator.userAgent) ||
      (navigator.userAgentData && navigator.userAgentData.platform === 'iPad');
  }

  return _ = {
    getUrlBooleanParameter: getUrlBooleanParameter,
    getUrlParameter: getUrlParameterOrFallbackFromUrl,
    isMobileDevice: isMobileDevice,
    isTabletDevice: isTabletDevice,
    parseHtml: function (rawHtml) {
      return jQuery("<div/>").html(rawHtml).text().trim();
    }
  };
})();

window.mcb.utilities.strings = (function () {
  return {
    toKebab: function (str) {
      return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase());
    },
    toCamel: function (str) {
      return str.replace(/-./g, x => x[1].toUpperCase());
    }
  }
})();

window.mcb.utilities.debug = (function () {
  const _verbose = true || window.mcb.utilities.browser.getUrlBooleanParameter("mcb-verbose");

  let _falied = false;
  const _areasString = window.mcb.utilities.browser.getUrlParameter("mcb-debug", "").toLowerCase().trim();
  const _areasStringIsAll = _areasString === "all" || _areasString === "true";
  const _areas = _areasStringIsAll ? [] : _areasString.split(",").filter((area) => {
    const trimmedArea = area.trim();
    if (trimmedArea.indexOf(" ") > -1) {
      console.error("Debugging areas cannot contain spaces.");
      _falied = true;

      return false;
    }

    return trimmedArea.length > 0;
  });

  const _hasAreas = _areas.length > 0;
  const _debugAll = _areasStringIsAll || _areas.includes('all');
  const _debugAny = _falied === false && (_debugAll || _hasAreas);

  const _classesString = window.mcb.utilities.browser.getUrlParameter("mcb-classes", "").toLowerCase().replace('mcb-ac--', '').trim();
  const _classes = _classesString.split(",").filter((addClass) => {
    const trimmedClass = addClass.trim();
    if (trimmedClass.indexOf(" ") > -1) {
      console.error("Added classes cannot contain spaces.");
      _falied = true;

      return false;
    }

    return trimmedClass.length > 0;
  });

  const _hasAddedClasses = _classes.length > 0;

  return {
    render: function () {
      if (_falied) {
        return null;
      }

      if (_debugAny) {
        document.body.classList.add('mcb-debugging');
      }

      if (_hasAreas) {
        for (let index = 0; index < _areas.length; index++) {
          const areaParts = _areas[index].split(".");
          let parent = '';
          for (let i = 0; i < areaParts.length; i++) {
            const part = areaParts[i];
            document.body.classList.add('mcb-debugging--' + part);
            parent += '-' + part;
          }

          document.querySelector('body').classList.add('mcb-debugging--' + _areas[index].toLowerCase());
        }
      }

      if (_hasAddedClasses) {
        for (let index = 0; index < _classes.length; index++) {
          document.querySelector('body').classList.add('mcb-ac--' + _classes[index]);
        }
      }

      return _debugAny || _hasAreas;
    },
    isDebuggingArea: function (area) {
      if (_falied || !_debugAny) {
        return false;
      }

      const areaLower = area.toLowerCase();
      if (_debugAll || _areas.includes(areaLower)) {
        return true;
      }

      const parts = areaLower.split('.');
      const parentArea = parts.slice(0, parts.length - 1).join(".");
      return _areas.includes(parentArea);
    },
    isVerbose: function () {
      return _verbose;
    },
    isDebugging: function () {
      return _debugAny;
    },
  }
})();
